import { Theme } from "@material-ui/core/styles";

export const getCardSize = ({ spacing }: Theme) => ({
  height: `calc(4.5rem + 114px + ${spacing.unit * 3}px + ${spacing.unit * 2}px)`,
  width: "292px"
});
